var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSidebarPie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_16831)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.88708 13.0581C2.52911 11.1259 2.87258 9.12941 3.85565 7.42793C4.83873 5.72645 6.39686 4.43175 8.24958 3.77686V9.96436L2.88708 13.0581Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9996 11.5903V3.3042C12.4451 3.30442 13.8651 3.68438 15.1175 4.40605C16.3698 5.12772 17.4106 6.16577 18.1356 7.41623C18.8606 8.66669 19.2443 10.0857 19.2484 11.5311C19.2524 12.9765 18.8766 14.3976 18.1587 15.6521C17.4407 16.9066 16.4057 17.9505 15.1574 18.6792C13.9091 19.4078 12.4912 19.7958 11.0458 19.8041C9.60044 19.8124 8.17822 19.4408 6.92161 18.7265C5.66499 18.0122 4.61809 16.9804 3.88574 15.7342L18.1445 7.4292",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_16831"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.554199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebarPie);
export default __webpack_public_path__ + "static/media/icon-sidebar-pie.e297029c4575175755e7d9ef46544cb3.svg";
export { ForwardRef as ReactComponent };